import React, { useEffect } from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ChoiceTypo, QuestionName } from "../../styles";
import { experienceSteps } from "../../../../Infrastructure/States/educatorStepsSlice";
import { questionThreeSX } from "./styles";

function QuestionThree() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.data);
  const questions = userData?.educator?.questions
  const years = useSelector((state) => state.educatorSteps.experienceStep.years);
  const question3 = "Approximately how many total years of teaching experience do you have?";

  const options = [
    { id: 0, text: "0-1" },
    { id: 1, text: "1-5" },
    { id: 2, text: "5-10" },
    { id: 3, text: "10+" },
  ];

  const handleOptionChange = (e) => {
    const optionValue = e.target.value;
    dispatch(experienceSteps({ optionValue, question: "three" }));
  };
  useEffect(() => {
    if (userData && questions && questions?.years) {
      dispatch(experienceSteps({ optionValue: questions.years, question: "three" }));
    }
  }, [userData, questions, dispatch])
  return (
    <Box sx={questionThreeSX.containerBox}>
      <Box sx={questionThreeSX.questionNameBox}>
        <QuestionName variant="h6">{question3}</QuestionName>
      </Box>
      <FormControl fullWidth>
        <RadioGroup onChange={handleOptionChange} value={years}>
          {options.map((option) => (
            <FormControlLabel
              key={option.id}
              value={option.text}
              control={<Radio sx={{...questionThreeSX.radio, color: theme.palette.primary.main }} size="medium" />}
              label={<ChoiceTypo>{option.text}</ChoiceTypo>}
              sx={questionThreeSX.formControlLabel}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

export default QuestionThree;